// extracted by mini-css-extract-plugin
export default {"grey":"FormLabel_grey__u5rSJ","formLabel":"FormLabel_formLabel__6C1sj","marginTop":"FormLabel_marginTop__Sai5h"};